import { objectValues } from "@ea/shared_components/utils/object";

import * as itsConfigurationsActions from "./itsConfigurations.actions";
import itsConfigurationsEpicsMap from "./itsConfigurations.epics";
import * as itsConfigurationsReducers from "./itsConfigurations.reducers";

const itsConfigurationsEpics = objectValues(itsConfigurationsEpicsMap);

export { itsConfigurationsActions, itsConfigurationsReducers, itsConfigurationsEpics };
